const module = { name: 'movie/shared/iconicImgUI', exports: {} }; const exports = module.exports;



const Selectors = {
    DEFAULT_ICONIC_IMG: '#mop-iconic-img-default',
    DEFAULT_ICONIC_IMG_BACKGROUND: '#mop-iconic-img-default-background',
}
function updateIconicImg(data, size) {
    const images = data.images[0] && data.images[0].imageUri && data.images[0].imageUri.size && data.images[0].imageUri.size;
    const src = images && (images[size] || images[500]);
    if (!src) {
        return;
    }
    const defaultImg = document.querySelector(Selectors.DEFAULT_ICONIC_IMG);
    defaultImg && (defaultImg.src = src);
    const defaultImgBackground = document.querySelector(Selectors.DEFAULT_ICONIC_IMG_BACKGROUND);
    defaultImgBackground && (defaultImgBackground.style = `background-image: url(${src});`);
}
module.exports = {
    updateIconicImg
};
export default module.exports;